module.exports = __webpack_public_path__ + "assets/3a30aa147a323027301d34af6e8704e3.mp3";